import React from 'react';
import { motion } from 'framer-motion';

interface PrivacyProps {
  onBack?: () => void;
}

const Privacy: React.FC<PrivacyProps> = ({ onBack }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className="legal-page"
    >
      <div className="container">
        <div className="legal-content">
          {onBack && (
            <button onClick={onBack} className="back-button">
              ← Back
            </button>
          )}
          <h1>Privacy Policy</h1>
          
          <section>
            <h2>Information We Collect</h2>
            <p>
              Cinquity collects information you provide directly to us, such as when you create an account, 
              use our clinical trial services, or contact us for support. This may include your name, 
              email address, phone number, and other relevant clinical trial data.
            </p>
          </section>

          <section>
            <h2>How We Use Your Information</h2>
            <p>
              We use the information we collect to provide, maintain, and improve our clinical trial 
              services, process transactions, communicate with you about your trials, and ensure 
              compliance with healthcare regulations.
            </p>
          </section>

          <section>
            <h2>Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal 
              information against unauthorized access, alteration, disclosure, or destruction. All clinical 
              trial data is handled in accordance with HIPAA and other applicable healthcare privacy regulations.
            </p>
          </section>

          <section>
            <h2>Your Rights</h2>
            <p>
              You have the right to access, update, or delete your personal information. You may also 
              opt-out of certain communications from us. To exercise these rights, please contact us at 
              privacy@cinquity.com.
            </p>
          </section>

          <section>
            <h2>Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes 
              by posting the new Privacy Policy on this page and updating the "Last Updated" date below.
            </p>
          </section>

          <div className="legal-footer">
            <p><strong>Last Updated:</strong> January 2025</p>
            <p><strong>Contact:</strong> privacy@cinquity.com</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Privacy;
